export default __webpack_public_path__ + "static/media/vendors_import_template.15934b3b.csv";